module.exports = __webpack_public_path__ + "img/picture10.28e7bbf0.png";